import { Box, Container } from '@mui/material';
import CNLoading from 'src/components/loading-cn/CNLoading';
import Page from 'src/components/page/page';
import CouponForm from './components/coupon-form';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import useLPCouponDetails from './coupon-lp-details.hook';
import RegisterCodes from 'src/modules/benefits/products/details/components/code-modal';
import RegisterCpfs from 'src/modules/benefits/products/details/components/cpf-modal';
import RedeemsModal from 'src/modules/benefits/products/details/components/redeem-modal';

export default function LPCouponDetails() {
  const hook = useLPCouponDetails();

  return (
    <Page title={hook.isEdit ? 'Editar Cupom' : 'Cadastrar Cupom'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={hook.isEdit ? 'Editar Cupom' : 'Cadastrar Cupom'}
          links={[]}
          action={[]}
        />
        {hook.isLoadingCouponDetails || hook.isLoadingStores || hook.isLoadingLocations ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <>
            <CouponForm hook={hook} />
            <RegisterCodes productDetailsHook={hook} />
            <RegisterCpfs productDetailsHook={hook} />
            <RedeemsModal productHook={hook} />
          </>
        )}
      </Container>
    </Page>
  );
}
